import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { RecoilRoot } from "recoil";
import UserLogin from "./auth/user-login";
import AuthGranted from "./auth/auth-granted";
import UserLoginCallback from "./auth/user-login-callback";
import AuthExpired from "./auth/expire";
import OAuthAuthorize from "./oauth/oauth-authorize";
import { CustomThemeProvider, lightTheme, useCustomTheme } from "./theme";
import DeveloperLogin from "./developer-auth/developer-login";
import CnUserLogin from "./cn-auth/cn-user-login";
import CnWechatCallback from "./cn-auth/cn-wechat-callback";

const AppContent = () => {
  const { theme } = useCustomTheme();
  const activeTheme = window.location.pathname.startsWith("/developer/")
    ? theme
    : lightTheme;

  return (
    <RecoilRoot>
      <ThemeProvider theme={activeTheme}>
        <CssBaseline />
        <Router>
          <Switch>
            <Route exact path="/" component={UserLogin} />
            <Route exact path="/developer/login" component={DeveloperLogin} />
            <Route exact path="/cn/login" component={CnUserLogin} />
            <Route
              exact
              path="/cn/wechat/callback"
              component={CnWechatCallback}
            />
            <Route exact path="/auth-granted" component={AuthGranted} />
            <Route exact path="/auth-expired" component={AuthExpired} />
            <Route exact path="/oauth/authorize" component={OAuthAuthorize} />
            <Route
              exact
              path="/user-login-callback"
              component={UserLoginCallback}
            />
            {/* Fallback to login for any other route */}
            <Route path="*">
              <Redirect to="/" />
            </Route>
          </Switch>
        </Router>
      </ThemeProvider>
    </RecoilRoot>
  );
};

export default function App() {
  return (
    <CustomThemeProvider>
      <AppContent />
    </CustomThemeProvider>
  );
}
